<template>
  <div v-if="hasValidDocuments" class="product-documentation">
    <p class="label">Documentation</p>

    <div class="documents-container">
      <template v-for="(document, index) in props.documents" :key="index">
        <div v-if="document.value" class="document">
          <p class="document-copy" @click="downloadPDF(document.value)">
            <span class="title">{{ document.title }}</span
            >.pdf
          </p>

          <DownloadIcon class="download-icon" />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import DownloadIcon from "@/assets/images/icons/download.svg";
import { useProductStore } from "~/stores/shopify/products";

const productStore = useProductStore();

const props = defineProps({
  documents: Object,
});
const downloadPDF = (file) => {
  productStore.downloadDocument(file);
};

const hasValidDocuments = computed(() =>
  props.documents?.some((doc) => doc && doc.value)
);
</script>

<style lang="scss" scoped>
.product-documentation {
  padding: 0 0 $padding-mobile-big;
  @include desktop {
    padding: 0 0 $padding-desktop-big;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 2.4rem;
  }
}
.label {
  @include caption-medium;
  padding-bottom: 4.5rem;

  @include desktop {
    grid-column: 1 / span 2;
  }
}

.documents-container {
  grid-column: 1 / span 4;
}

.document {
  padding: 2.3rem 0;
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;

  @include desktop {
    cursor: pointer;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.5px;
    background-color: rgba($color: #000000, $alpha: 1);
  }
}

.document-copy {
  color: #929292;
  font-family: $beaufort-regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21.156px; /* 151.111% */
  span {
    color: black;
    @include body-regular;
    font-weight: 600;
  }
}
</style>
